import axios from "axios";
import {
  getToken as getLegacyToken,
  handleAuthError,
  resetAuthRetryCount,
  createAuthRetryState,
} from "./_tokenRefresh";
import { getResourceTokenIfAvailable } from "./resourceToken";

export let baseUrl = "https://api-inbox.skedsocial.com";

// SKED_API_ENV overrides NODE_ENV for API URL selection
const apiEnv = process.env.SKED_API_ENV || process.env.NODE_ENV;

if (apiEnv === "dev") {
  baseUrl = "/inbox-api";
} else if (apiEnv === "staging") {
  baseUrl = "https://api-inbox-staging.skedsocial.com";
}

const defaultOptions = {
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
};

let inboxAuthMode = "unknown";

export function resetInboxAuthMode() {
  inboxAuthMode = "unknown";
}

export async function getToken(force = false) {
  if (inboxAuthMode !== "legacy") {
    const token = await getResourceTokenIfAvailable("inbox", force);
    if (token) {
      inboxAuthMode = "better-auth";
      return token;
    }
    inboxAuthMode = "legacy";
  }

  return getLegacyToken(force);
}

export const skedInboxApi = axios.create(defaultOptions);

skedInboxApi.interceptors.request.use(async (config) => {
  const token = await getToken();
  config.headers.Authorization = `Bearer ${token}`;
  return config;
}, null);

const skedInboxApiRetryState = createAuthRetryState();

skedInboxApi.interceptors.response.use(
  (response) => {
    resetAuthRetryCount(skedInboxApiRetryState);
    return response;
  },
  async (error) => {
    if (error?.response?.status !== 401) {
      return Promise.reject(error);
    }

    if (inboxAuthMode === "legacy") {
      return handleAuthError(
        skedInboxApi,
        error,
        "skedInboxApi",
        skedInboxApiRetryState
      );
    }

    if (error.config && !error.config.__skedInboxResourceTokenRetried) {
      error.config.__skedInboxResourceTokenRetried = true;
      error.config.headers.Authorization = `Bearer ${await getToken(true)}`;
      return skedInboxApi(error.config);
    }

    return Promise.reject(error);
  }
);
